import { render, staticRenderFns } from "./ListaPartite.vue?vue&type=template&id=be4beb52"
import script from "./ListaPartite.vue?vue&type=script&lang=js"
export * from "./ListaPartite.vue?vue&type=script&lang=js"
import style0 from "./ListaPartite.vue?vue&type=style&index=0&id=be4beb52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListaPartite.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Funpkg.com%2Fleaflet%2Fdist%2Fleaflet.css"
if (typeof block0 === 'function') block0(component)

export default component.exports